import type { SxProps, Theme } from "@mui/material/styles";

export const root =
  (size: "sm" | "md"): SxProps<Theme> =>
  (theme) => ({
    display: "block",
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: size === "sm" ? "0.625rem" : "0.75rem",
    mb: 0.5,
  });
